import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  root: {
    '& .MuiAlert-standardError': { width: '100%' },
    '& .MuiAlert-action': {
      marginTop: '4px',
      alignItems: 'baseline',
    },
  },
});
